import { TranslateService } from '@ngx-translate/core';
import { FilterRule } from '../../../api/api-clientInformation';
import { Column } from '../filter-dialog/constants';

export function getFilterLabels(rules: FilterRule[], columns: Column[], translate: TranslateService): string[] {
  const fields = new Set(rules.map(r => r.field));
  return [...fields].map(field => {
    const column = columns.find(c => c.id === field);
    return column ? translate.instant(column.label) : field;
  });
}
